enum DialogList {
    UPDATE_PASSWORD = 'UPDATE_PASSWORD',
    LOGIN_SUBMIT_AUTH_CODE = 'LOGIN_SUBMIT_AUTH_CODE',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    EXPIRED_PASSWORD = 'EXPIRED_PASSWORD',
    GET_MERIDIANS = 'GET_MERIDIANS',
    ADD_TOWNSHIP = 'ADD_TOWNSHIP',
    ADD_SECTION = 'ADD_SECTION',
    ADD_TRACT = 'ADD_TRACT',
    ADD_HORIZON = 'ADD_HORIZON',
    ADD_COUNTY = 'ADD_COUNTY',
    ADD_OWNERSHIP = 'ADD_OWNERSHIP',
    COPY_OWNERSHIP = 'COPY_OWNERSHIP',
    MANAGE_LEASEHOLD = 'MANAGE_LEASEHOLD',
    ADD_ADDITIONAL_OWNERSHIP = 'ADD_ADDITIONAL_OWNERSHIP',
    ADD_WI_OWNERSHIP = 'ADD_WI_OWNERSHIP',
    ADD_OWNER = 'ADD_OWNER',
    EDIT_HORIZON = 'EDIT_HORIZON',
    DELETE_HORIZON = 'DELETE_HORIZON',
    SEQUENCE_HORIZONS = 'SEQUENCE_HORIZONS',
    EXAMINED_HISTORY = 'EXAMINED_HISTORY',
    SURFACE_EXAMINED_HISTORY = 'SURFACE_EXAMINED_HISTORY',
    LEASEHOLD_PICKER = 'LEASEHOLD_PICKER',
    LEASEHOLD_FILE_UPLOAD = 'LEASEHOLD_FILE_UPLOAD',
    AMENDMENT_TO_OGML = 'AMENDMENT_TO_OGML',
    OWNER_LIST_FILTER = 'OWNER_LIST_FILTER',
    LEASING_OWNER_SEARCH = 'LEASING_OWNER_SEARCH',
    CONFIRM_CLAUSE_DELETE = 'CONFIRM_CLAUSE_DELETE',
    PERSONNEL_SUMMARY = 'PERSONNEL_SUMMARY',
    AD_HOC_CLAUSE = 'AD_HOC_CLAUSE',
    PDF_VIEWER = 'PDF_VIEWER',
    PDF_WINDOW = 'PDF_WINDOW',
    CREATE_FEEDBACK = 'CREATE_FEEDBACK',
    DELETE_CLIENT = 'DELETE_CLIENT',
    DELETE_TRACT = 'DELETE_TRACT',
    DELETE_SECTION = 'DELETE_SECTION',
    CLAUSE_DESCRIPTION = 'CLAUSE_DESCRIPTION',
    CONFIRM_OWNERSHIP_DELETE = 'CONFIRM_OWNERSHIP_DELETE',
    ADD_STAFF = 'ADD_STAFF',
    ADD_LANDMAN = 'ADD_LANDMAN',
    ADD_COMMENT = 'ADD_COMMENT',
    EDIT_COMMENT = 'EDIT_COMMENT',
    STAFF_LANDMAN = 'STAFF_LANDMAN',
    EDIT_TOWNSHIP = 'EDIT_TOWNSHIP',
    DELETE_TOWNSHIP = 'DELETE_TOWNSHIP',
    EDIT_SECTION = 'EDIT_SECTION',
    LEASEHOLD_SAVE_BEFORE_ADDING_WI = 'LEASEHOLD_SAVE_BEFORE_ADDING_WI',
    ADD_ORRI_OWNERSHIP = 'ADD_ORRI_OWNERSHIP',
    CONFIRM_LEASEHOLD_OWNERSHIP_DELETE = 'CONFIRM_LEASEHOLD_OWNERSHIP_DELETE',
    CONFIRM_CONTRACT_OWNERSHIP_DELETE = 'CONFIRM_CONTRACT_OWNERSHIP_DELETE',
    MANAGE_AGREEMENTS = 'MANAGE_AGREEMENTS',
    ADD_TOWNSHIP_EAST = 'ADD_TOWNSHIP_EAST',
    ADD_MAP_EAST = 'ADD_MAP_EAST',
    CREATE_INVOICE = 'CREATE_INVOICE',
    MANAGE_DEVIATIONS = 'MANAGE_DEVIATIONS',
    CHOOSE_ACTIVE_LEASEHOLD = 'CHOOSE_ACTIVE_LEASEHOLD',
    AGREEMENT_STATUS = 'AGREEMENT_STATUS',
    VOID_AGREEMENT = 'VOID_AGREEMENT',
    TRACT_LIST_DELTA = 'TRACT_LIST_DELTA',
    ADD_LEASEHOLD = 'ADD_LEASEHOLD',
    DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT',
    DELETE_LEASEHOLD = 'DELETE_LEASEHOLD',
    CREATE_LESSEE = 'CREATE_LESSEE',
    DOCUMENT_VIEWER = 'DOCUMENT_VIEWER',
    LEASE_PACKET_BUILDER = 'LEASE_PACKET_BUILDER',
    DELETE_DOC = 'DELETE_DOC',
    LPR_VIEWER = 'LPR_VIEWER',
    RECEIPT_VIEWER = 'RECEIPT_VIEWER',
    CREATE_AMMENDMENT = 'CREATE_AMMENDMENT',
    DOWNLOAD_DBF = 'DOWNLOAD_DBF',
    OWNER_NOTE = 'OWNER_NOTE',
    ADD_OWNER_NOTE = 'ADD_OWNER_NOTE',
    ADD_INVOICE = 'ADD_INVOICE',
    DELETE_LEASE = 'DELETE_LEASE',
    ADD_RECORDING_FEE = 'ADD_RECORDING_FEE',
    CREATE_CHECK = 'CREATE_CHECK',
    MANAGE_CHECKS = 'MANAGE_CHECKS',
    MANAGE_INVOICE_GROUPS = 'MANAGE_INVOICE_GROUPS',
    EXTEND_CHECK_DUE_DATE = 'EXTEND_CHECK_DUE_DATE',
    EXTEND_LEASEHOLDS = 'EXTEND_LEASEHOLDS',
    STAFFING_LANDMEN = 'STAFFING_LANDMEN',
    ADD_RUNSHEET = 'ADD_RUNSHEET',
    CONFIRM_TRACT_DELETE = 'CONFIRM_TRACT_DELETE',
    MEMO_VIEWER = 'MEMO_VIEWER',
    OOP_VIEWER = 'OOP_VIEWER',
    FILE_TOO_LARGE_TO_UPLOAD = 'FILE_TOO_LARGE_TO_UPLOAD',
    ADD_PERSONNEL = 'ADD_PERSONNEL',
    SCORECARD_COMMENT = 'SCORECARD_COMMENT',
    DEFAULT_PAY_HISTORY = 'DEFAULT_PAY_HISTORY',
    DEFAULT_BILL_HISTORY = 'DEFAULT_BILL_HISTORY',
    EMPLOYEE_PAY_HISTORY = 'EMPLOYEE_PAY_HISTORY',
    FIND_VENDOR = 'FIND_VENDOR',
    FIND_CLIENT = 'FIND_CLIENT',
    FIND_PROJECT = 'FIND_PROJECT',
    FIND_SUBCODE = 'FIND_SUBCODE',
    FIND_ALTSUBCODE = 'FIND_ALTSUBCODE',
    ADD_VENDOR_INVOICES = 'ADD_VENDOR_INVOICES',
    INVOICE_GROUPING = 'INVOICE_GROUPING',
    FIND_PERSON = 'FIND_PERSON',
    FIND_PROJECT_STAFF = 'FIND_PROJECT_STAFF',
    FIND_AVAILABLE_ACCOUNTS = 'FIND_AVAILABLE_ACCOUNTS',
    DEFINE_BUDGET_CATEGORY = 'DEFINE_BUDGET_CATEGORY',
    WARNING = 'WARNING',
    INFO = 'INFO',
    VENDOR_REPORTS = 'VENDOR_REPORTS',
    AP_1099_MAINTENANCE = 'AP_1099_MAINTENANCE',
    COMPANY_MAINTENANCE = 'COMPANY_MAINTENANCE',
    AP_1099_REPORT = 'AP_1099_REPORT',
    LM_1099_MAINTENANCE = 'LM_1099_MAINTENANCE',
    LM_1099_REPORT = 'LM_1099_REPORT',
    EXCEL_FILE = 'EXCEL_FILE',
    REFRESH_BILLING_DATA = 'REFRESH_BILLING_DATA',
    ADD_VENDOR = 'ADD_VENDOR',
    ADD_CLIENT = 'ADD_CLIENT',
    ADD_VENDOR_EX = 'ADD_VENDOR_EX',
    AP_TERMS = 'AP_TERMS',
    REPORT_OPTIONS = 'REPORT_OPTIONS',
    AP_VOUCHER_REPORT = 'AP_VOUCHER_REPORT',
    MANAGE_VENDOR_DOCUMENTS = 'MANAGE_VENDOR_DOCUMENTS',
    MANAGE_CLIENT_DOCUMENTS = 'MANAGE_CLIENT_DOCUMENTS',
    CLIENT_NAME_EXISTS = 'CLIENT_NAME_EXISTS',
    VENDOR_EXCEL_EXPORT = 'VENDOR_EXCEL_EXPORT',
    AR_REPORT = 'AR_REPORT',
    AR_CLIENT_NOTES = 'AR_CLIENT_NOTES',
    COMPANY_EXPENSES_REPORT = 'COMPANY_EXPENSES_REPORT',
    INVOICE_COUNTY_BREAKDOWN_REPORT = 'INVOICE_COUNTY_BREAKDOWN_REPORT',
    LAND_RENEW_REVENUE_REPORT = 'LAND_RENEW_REVENUE_REPORT',
    CLIENTS_BILLED_REPORT = 'CLIENTS_BILLED_REPORT',
    CLIENTS_BILLED_RENEW_REPORT = 'CLIENTS_BILLED_RENEW_REPORT',
    CLIENTS_BILLED_WESTLAND_REPORT = 'CLIENTS_BILLED_WESTLAND_REPORT',
    PROJECT_PM_MARGIN_REPORT = 'PROJECT_PM_MARGIN_REPORT',
    PROJECT_MARGINS_REPORT = 'PROJECT_MARGINS_REPORT',
    WTEXAS_SECTION_REPORT = 'WTEXAS_SECTION_REPORT',
    EASTERN_SECTION_REPORT = 'EASTERN_SECTION_REPORT',
    SECTION_UNIT_LIST_REPORT = 'SECTION_UNIT_LIST_REPORT',
    OFFICE_EXPENSE_REPORT_OPTIONS = 'OFFICE_EXPENSE_REPORT_OPTIONS',
    CHOOSE_VOUCHERS_TO_PAY = 'CHOOSE_VOUCHERS_TO_PAY',
    ENTER_CHECK_NUMBER = 'ENTER_CHECK_NUMBER',
    CREATE_CHECK_WARNING = 'CREATE_CHECK_WARNING',
    VOID_VOUCHER = 'VOID_VOUCHER',
    TSDI_EMPLOYEES = 'TSDI_EMPLOYEES',
    CREDIT_CARD_STATEMENT_MAINTENANCE = 'CREDIT_CARD_STATEMENT_MAINTENANCE',
    LOAD_RAW_DATA_FILE = 'LOAD_RAW_DATA_FILE',
    LOAD_RAW_DATA_FILE_FOR_STATEMENT = 'LOAD_RAW_DATA_FILE_FOR_STATEMENT',
    INFO_STATEMENT = 'INFO_STATEMENT',
    OUTPUT_DESTINATION = 'OUTPUT_DESTINATION',
    FLAG_REASON_DIALOG = 'FLAG_REASON_DIALOG',
    SHOW_FLAG_NOTES_DIALOG = 'SHOW_FLAG_NOTES_DIALOG',
    DATE_PICKER_DIALOG = 'DATE_PICKER_DIALOG',
    CREATE_BACK_OFFICE_ACCOUNT_DIALOG = 'CREATE_BACK_OFFICE_ACCOUNT_DIALOG',
    ADD_ALT_SUBCODE = 'ADD_ALT_SUBCODE',
    ALT_OR_SUBCODE_BILLING_DIALOG = 'ALT_OR_SUBCODE_BILLING_DIALOG',
    EDIT_TIME_AND_EXPENSE = 'EDIT_TIME_AND_EXPENSE',
    CREATE_MANUAL_INVOICE = 'CREATE_MANUAL_INVOICE',
    GENERATE_TIMESHEET = 'GENERATE_TIMESHEET',
    GENERATE_TIME_SUMMARY = 'GENERATE_TIME_SUMMARY',
    INVOICE_DESCRIPTION = 'INVOICE_DESCRIPTION',
    INVOICE_BREAKDOWN = 'INVOICE_BREAKDOWN',
    GENERATE_INVOICES = 'GENERATE_INVOICES',
    INVOICE_DETAILS = 'INVOICE_DETAILS',
    VOID_INVOICE = 'VOID_INVOICE',
    GENERATE_INVOICE_DOCUMENTS = 'GENERATE_INVOICE_DOCUMENTS',
    MANAGE_INVOICE_DOCUMENTS = 'MANAGE_INVOICE_DOCUMENTS',
    ADD_INVOICE_DOCUMENT = 'ADD_INVOICE_DOCUMENT',
    PERSONNEL_TAX_INFORMATION = 'PERSONNEL_TAX_INFORMATION',
    PERSONNEL_PERFORMANCE_COMMENTS = 'PERSONNEL_PERFORMANCE_COMMENTS',
    PERSONNEL_HIRING_HISTORY = 'PERSONNEL_HIRING_HISTORY',
    PERSONNEL_ADVANCED_QUICK_FIND = 'PERSONNEL_ADVANCED_QUICK_FIND',
    PERSONNEL_VIEW_PAPERWORK = 'PERSONNEL_VIEW_PAPERWORK',
    PAPERWORK_COMMENT = 'PAPERWORK_COMMENT',
    INSURANCE_COMMENT = 'INSURANCE_COMMENT',
    EDIT_INVOICE_GROUP = 'EDIT_INVOICE_GROUP',
    EDIT_IG_COVER_LETTER = 'EDIT_IG_COVER_LETTER',
    GENERATE_EXCEL_SUMMARY = 'GENERATE_EXCEL_SUMMARY',
    GENERATE_EXCEL_INVOICE_LIST = 'GENERATE_EXCEL_INVOICE_LIST',
    GENERATE_SUPPLIER_LINK_CSV = 'GENERATE_SUPPLIER_LINK_CSV',
    NO_SELECTED_INVOICES = 'NO_SELECTED_INVOICES',
    CONFIRM_GENERATE_IG_DOCS = 'CONFIRM_GENERATE_IG_DOCS',
    CONFIRM_DELETE_TIME_ENTRY = 'CONFIRM_DELETE_TIME_ENTRY',
    GENERATE_INVOICE_LISTING = 'GENERATE_INVOICE_LISTING',
    UPDATE_PAY_HISTORY = 'UPDATE_PAY_HISTORY',
    UPDATE_BILLING_HISTORY = 'UPDATE_BILLING_HISTORY',
    SHOW_PAY_EXCEPTIONS = 'SHOW_PAY_EXCEPTIONS',
    SHOW_BILL_EXCEPTIONS = 'SHOW_BILL_EXCEPTIONS',
    PAY_EXCEPTIONS_AND_HISTORY = 'PAY_EXCEPTIONS_AND_HISTORY',
    BILL_EXCEPTIONS_AND_HISTORY = 'BILL_EXCEPTIONS_AND_HISTORY',
    EDIT_BENEFITS = 'EDIT_BENEFITS',
    ADD_BENEFIT = 'ADD_BENEFIT',
    EDIT_YEAR_NOTE = 'EDIT_YEAR_NOTE',
    BENEFITS_EMPLOYEE_SEARCH = 'BENEFITS_EMPLOYEE_SEARCH',
    YEAR_MATRIX = 'YEAR_MATRIX',
    INSURANCE_DASHBOARD = 'INSURANCE_DASHBOARD',
    BENEFITS_DASHBOARD = 'BENEFITS_DASHBOARD',
    QUERY_YEAR = 'QUERY_YEAR',
    EDIT_BENEFIT_RATE = 'EDIT_BENEFIT_RATE',
    PTO_DASHBOARD = 'PTO_DASHBOARD',
    CONFIRM_DELETE = 'CONFIRM_DELETE',
    ADD_CLIENT_DEPOSIT_CHECK = 'ADD_CLIENT_DEPOSIT_CHECK',
    GENERATE_BENEFITS_REPORT = 'GENERATE_BENEFITS_REPORT',
    UPDATE_TERM_HIRE_DATE = 'UPDATE_TERM_HIRE_DATE',
    ADD_ACCESS_ACCOUNT = 'ADD_ACCESS_ACCOUNT',
    VIEW_LM_EXPENSES = 'VIEW_LM_EXPENSES',
    FIND_MANAGER = 'FIND_MANAGER',
    TRANSFER_OFFICE_EXPENSE =  'TRANSFER_OFFICE_EXPENSE',
    MANAGE_OFFICE_EXPENSE_UNIT =  'MANAGE_OFFICE_EXPENSE_UNIT',
    CHECK_REGISTER_GENERATE = 'CHECK_REGISTER_GENERATE',
    CHECK_REGISTER_WITHHOLDING = 'CHECK_REGISTER_WITHHOLDING',
    CHECK_REGISTER_WORKERS_COMP = 'CHECK_REGISTER_WORKERS_COMP',
    CHECK_REGISTER_REPORT = 'CHECK_REGISTER_REPORT',
    CHECK_REGISTER_BNOTICE = 'CHECK_REGISTER_BNOTICE',
    CHECK_REGISTER_STATS = 'CHECK_REGISTER_STATS',
    CHECK_EXCEL_REPORT = 'CHECK_EXCEL_REPORT',
    CHECK_REGISTER_DOWNLOAD_STUBS_MISSING = 'CHECK_REGISTER_DOWNLOAD_STUBS_MISSING',
    CHECK_REGISTER_PRINT_TS = 'CHECK_REGISTER_PRINT_TS',
    CHECK_REGISTER_NO_SELECTION = 'CHECK_REGISTER_NO_SELECTION',
    CHECK_REGISTER_DOCUMENTS = 'CHECK_REGISTER_DOCUMENTS',
    CHECK_REGISTER_VOID = 'CHECK_REGISTER_VOID',
    NACHA_BATCH_LIST = 'NACHA_BATCH_LIST',
    NACHA_GENERATE = 'NACHA_GENERATE',
    NACHA_HEADER_BATCH = 'NACHA_HEADER_BATCH',
    NACHA_CONTROL_DATA = 'NACHA_CONTROL_DATA',
    AR_HISTORY_PAYMENTS = 'AR_HISTORY_PAYMENTS',
    AR_HISTORY_REPORT = 'AR_HISTORY_REPORT',
    AR_HISTORY_REPORT_REQUIREMENTS = 'AR_HISTORY_REPORT_REQUIREMENTS',
    APPLY_OVERPAYMENT = 'APPLY_OVERPAYMENT',
    AR_RECON_OVER_UNDER = 'AR_RECON_OVER_UNDER',
    MANAGE_DEPOSIT_DOCUMENTS = 'MANAGE_DEPOSIT_DOCUMENTS',
    EMPLOYEE_PAYROLL_NO_PERIOD = 'EMPLOYEE_PAYROLL_NO_PERIOD',
    EMPLOYEE_PAYROLL_BUILD_CONFIRM = 'EMPLOYEE_PAYROLL_BUILD_CONFIRM',
    EMPLOYEE_PAYROLL_TEXT_EXPORT = 'EMPLOYEE_PAYROLL_TEXT_EXPORT',
    EMPLOYEE_PAYROLL_EXCEL_REPORT = 'EMPLOYEE_PAYROLL_EXCEL_REPORT',
    EMPLOYEE_PAYROLL_CPI_SPECIAL = 'EMPLOYEE_PAYROLL_CPI_SPECIAL',
    EMPLOYEE_PAYROLL_LOCK_PERIOD = 'EMPLOYEE_PAYROLL_LOCK_PERIOD',
    EMPLOYEE_PAYROLL_TIME_EMP_CUTOFF = 'EMPLOYEE_PAYROLL_TIME_EMP_CUTOFF',
    EMPLOYEE_PAYROLL_PERIOD_COUNT = 'EMPLOYEE_PAYROLL_PERIOD_COUNT',
    EMPLOYEE_PAYROLL_HIST_PERF_BONUS = 'EMPLOYEE_PAYROLL_HIST_PERF_BONUS',
    EDIT_NONRECON_TIME = 'EDIT_NONRECON_TIME',
    NONRECON_CHANGE_DETAIL = 'NONRECON_CHANGE_DETAIL',
    ICCO_EXCEL_REPORT = 'ICCO_EXCEL_REPORT',
    ICCO_MULTI_OFFICE_CHECKS = 'ICCO_MULTI_OFFICE_CHECKS',
    CONFIRM_COMMISSION_ACTION = 'CONFIRM_COMMISSION_ACTION',
    BUILD_SINGLE_MANAGER_REVIEW = 'BUILD_SINGLE_MANAGER_REVIEW',
    COMMISSION_REPORT_PARAMS = 'COMMISSION_REPORT_PARAMS',
    COMMISSION_EXCEL_REPORT = 'COMMISSION_EXCEL_REPORT',
    EXISTING_LM_MATCH = 'EXISTING_LM_MATCH',
    PCASM_TOTALS = 'PCASM_TOTALS',
    PRODUCTION_BONUS_HISTORY = 'PRODUCTION_BONUS_HISTORY',
    NS_CONTRACTORS = 'NS_CONTRACTORS',
    PAY_PERIOD_RANGE = 'PAY_PERIOD_RANGE',
    PM_LANDMEN = 'PM_LANDMEN',
    REVENUE_REPORT = 'REVENUE_REPORT',
    INVOICE_OFFICE_BREAKDOWN_REPORT = 'INVOICE_OFFICE_BREAKDOWN_REPORT',
    TIME_RPT_REPORT = 'TIME_RPT_REPORT',
    CONTRACTORS_BILLED_REPORT = 'CONTRACTORS_BILLED_REPORT',
    SECTION_BILLING_REPORT = 'SECTION_BILLING_REPORT',
    GENERATE_BILLING_SUMMARY_REPORT = 'GENERATE_BILLING_SUMMARY_REPORT',
    ADD_COST_BREAKDOWN_REPORT = 'ADD_COST_BREAKDOWN_REPORT',
    COST_BREAKDOWN_EXCEL = 'COST_BREAKDOWN_EXCEL',
    COST_BREAKDOWN_JOB = 'COST_BREAKDOWN_JOB',
    INVOICE_CONTRACTOR_PAY_BREAKDOWN_REPORTS = 'INVOICE_CONTRACTOR_PAY_BREAKDOWN_REPORTS'
}

export default DialogList;



// WEBPACK FOOTER //
// ./src/dialogs.ts